import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@/modules/common/components/Breadcrumbs';
import '../styles/ContentHeader.scss';

const ContentHeader = ({breadcrumbs}) => {
    const header = breadcrumbs[breadcrumbs.length - 1].name;

    return (
        <Paper className="content-header" variant="outlined" square={true} component="header">
            <Typography variant="h1" component="h1">{header}</Typography>
            <Breadcrumbs breadcrumbs={breadcrumbs}/>
        </Paper>
    );
};

ContentHeader.propTypes = {
    breadcrumbs: PropTypes.array.isRequired,
};

export default ContentHeader;
